
import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { HomeSectionProps } from './HomeSectionProps';

const Hero: React.FC<HomeSectionProps> = ({ className }) => {
  const { user, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  
  const navigateToGuide = useCallback(() => {
    navigate("/guide");
  }, [navigate]);
  const navigateToLogin = useCallback(() => {
    if (isAuthenticated && user) {
      navigate("/dashboard");
    } else {
      navigate("/login");
    }
  }, [isAuthenticated, user, navigate]);
  return (
    <section className={`py-5 text-center text-lg-start keep-all ${className ?? ''}`} style={{ background: 'linear-gradient(to bottom right, #fee2e2, #ffffff, #dbeafe)' }}>
      <div className="container py-5">
        <div className="row align-items-center g-5">
          <div className="col-lg-6">
            <span className="badge rounded-pill text-bg-danger bg-opacity-75 mb-3" style={{ fontSize: '0.75rem', fontWeight: 600, padding: '0.4em 0.8em' }}>🏆 2025 KBO 시즌 진행중</span>
            <h1 className="display-4 fw-bold lh-tight">
              한국 프로야구<br />
              <span style={{ background: 'linear-gradient(to right, #dc2626, #3b82f6)', WebkitBackgroundClip: 'text', backgroundClip: 'text', color: 'transparent' }}>판타지 게임</span>
            </h1>
            <p className="lead text-muted my-4">KBO 리그의 실제 선수들로 나만의 드림팀을 구성하고,<br />실시간 경기 결과에 따라 포인트를 획득하세요.<br />친구들과 함께 리그를 만들어 진정한 야구 매니저가 되어보세요!</p>
            <div className="d-grid gap-2 d-sm-flex justify-content-center justify-content-lg-start mb-4">
              <button className="btn btn-lg text-white bg-gradient-custom" onClick={navigateToLogin}>
                지금 시작하기 <i className="bi bi-arrow-right ms-2"></i>
              </button>
              <button className="btn btn-lg btn-outline-secondary" onClick={navigateToGuide}>게임 방법 보기</button>
            </div>
            <div className="d-flex justify-content-center justify-content-lg-start gap-4 text-muted">
              <div className="d-flex align-items-center gap-2"><i className="bi bi-people-fill text-primary"></i><span>친구와 함께</span></div>
              <div className="d-flex align-items-center gap-2"><i className="bi bi-lightning-charge-fill text-success"></i><span>실시간 업데이트</span></div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="video-responsive">
              <iframe width="560" height="315" src="https://www.youtube.com/embed/o92AvE69Iro?si=wHBT2kQvdRVg9sRb" title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
